import ESTIMATE_CONSTANT from "../../constant/estimateConstant"
import type EstimateValues from "../../types/params"
import getSpecCategoryDisplayCondition from "./specCategories/getSpecCategoryDisplayCondition"

const getBaseColor = (values: EstimateValues) => {
  const condition = getSpecCategoryDisplayCondition(values)

  if (condition.resistPrinting) {
    switch (values.resistColor) {
      case ESTIMATE_CONSTANT.レジスト色["緑(リジッド)"].value:
      case ESTIMATE_CONSTANT.レジスト色["緑(メタル)"].value:
        return "green"
      case ESTIMATE_CONSTANT.レジスト色["赤(リジッド)"].value:
      case ESTIMATE_CONSTANT.レジスト色["赤(メタル)"].value:
        return "red"
      case ESTIMATE_CONSTANT.レジスト色["青(リジッド)"].value:
      case ESTIMATE_CONSTANT.レジスト色["青(メタル)"].value:
        return "blue"
      case ESTIMATE_CONSTANT.レジスト色["黄(リジッド)"].value:
      case ESTIMATE_CONSTANT.レジスト色["黄(メタル)"].value:
        return "yellow"
      case ESTIMATE_CONSTANT.レジスト色["白(リジッド)"].value:
      case ESTIMATE_CONSTANT.レジスト色["白(メタル)"].value:
        return "white"
      case ESTIMATE_CONSTANT.レジスト色["黒(リジッド)"].value:
      case ESTIMATE_CONSTANT.レジスト色["黒(メタル)"].value:
        return "black"
      case ESTIMATE_CONSTANT.レジスト色["黒（つや消し）(リジッド)"].value:
      case ESTIMATE_CONSTANT.レジスト色["黒（つや消し）(メタル)"].value:
        return "matteBlack"
      case ESTIMATE_CONSTANT.レジスト色.紫.value:
        return "purple"
    }
  }

  if (condition.coverlay) {
    const isGreenResist = values.coverLay === ESTIMATE_CONSTANT.カバーレイ.グリーンレジスト.value
    if (isGreenResist) {
      return "green"
    }
    switch (values.coverLayColor) {
      case ESTIMATE_CONSTANT.カバーレイ色.白色.value:
        return "white"
      case ESTIMATE_CONSTANT.カバーレイ色.黒色.value:
        return "black"
      case ESTIMATE_CONSTANT.カバーレイ色.標準色.value:
        return "orange"
    }
  }

  throw new Error("レジスト色またはカバーレイ色の値が不正です。")
}

export default getBaseColor
